<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "HelpcenterApp"
};
</script>

<style lang="scss">
@import "normalize-css";

@import "@/assets/support";
@import "@/assets/_base";
@import "@/assets/modules/forms";
@import "@/assets/modules/popups";
</style>
